import { DocumentDownload } from '@dreamstack/icons'
import type { NewsArticleFileFragment } from '@dreamstack/investors-graphql'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import tw, { styled } from 'twin.macro'

const StyledLink = styled.a<{ whiteText?: boolean }>(({ whiteText }) => [
  whiteText
    ? tw`text-accentroWhite-full mt-px-6`
    : tw`text-accentroAqua-full mt-px-32`,
  tw`font-semibold text-px-20 leading-px-30 flex items-center`,
])

export const NewsArticleFile: FunctionComponent<React.PropsWithChildren<{
  file?: NewsArticleFileFragment['file']
  whiteText?: boolean
}>> = ({ file, whiteText = false }) => {
  if (!file || !file.url) return null
  return (
    <div tw="w-full">
      <Link href={file.url} passHref legacyBehavior>
        <StyledLink target="_blank" whiteText={whiteText}>
          <DocumentDownload tw="pr-px-8 h-px-32 w-px-32 flex-shrink-0" />
          <span tw="overflow-ellipsis overflow-hidden">{file.title}</span>
        </StyledLink>
      </Link>
    </div>
  )
}
